/* eslint-disable */
const validate = (input: any) => {
  interface Data {
    password: string
    email: string
  }

  let errors = <Data>{
    password: "",
    email: ""
  }
  if (!input.email) {
    errors.email = 'email is required'
    return errors
  } else if (
    !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(
      input.email
    )
  ) {
    errors.email = 'email is invalid'
    return errors
  }

  return errors
}

export default validate
